import React from "react";
import GrComponentFactory from "../gr_component_factory";
import classnames from "classnames";
import { nextTransitionMessage, prevTransitionMessage } from "../../modules/carousel/carousel_helper";

export default GrComponentFactory.createClass({

  displayName: "PreviousArrow",

  propTypes: {
    carouselId: React.PropTypes.string.isRequired,
    currentSlide: React.PropTypes.number,
    slideCount: React.PropTypes.number,
    carouselSlidesToShow: React.PropTypes.number,
    carouselWrapAround: React.PropTypes.bool,
    clickHandler: React.PropTypes.func,
    carouselReverseScroll: React.PropTypes.bool,
    smTopOffset: React.PropTypes.number,
    trackRef: React.PropTypes.object,
  },

  clickHandler (options, e) {
    e.preventDefault();
    this.props.clickHandler(options, e);
  },

  render () {
    const message = this.props.carouselReverseScroll ? nextTransitionMessage : prevTransitionMessage;
    let prevHandler = this.clickHandler.bind(this, { message });
    const prevClasses = ["gr-carousel__arrow", "gr-carousel__arrow--prev"];

    if (this.props.carouselReverseScroll) {
      if (!this.props.carouselWrapAround) {
        if (this.props.currentSlide >= (this.props.slideCount - this.props.carouselSlidesToShow)) {
          prevClasses.push("gr-carousel__arrow--disabled");
          prevHandler = null;
        }
        if (this.props.slideCount <= this.props.carouselSlidesToShow) {
          prevClasses.push("gr-carousel__arrow--disabled");
          prevHandler = null;
        }
      }
    } else {
      if (!this.props.carouselWrapAround && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.carouselSlidesToShow)) {
        prevClasses.push("gr-carousel__arrow--disabled");
        prevHandler = null;
      }
    }

    const prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: classnames(prevClasses),
      style: {top: `${this.props.smTopOffset}px`},
      onClick: prevHandler,
    };
    return (<div><button aria-label="Previous" type="button" {...prevArrowProps} /></div>);
  },
});
